import { InputRadioButton } from "App/Component/ui";
import React from "react";

const RenderIsRootParentTrue = ({ formData, setFormData }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        marginLeft: "5px",
        marginTop: "0.5rem",
      }}>
      <InputRadioButton
        label={"Is Root"}
        size={"15"}
        id='is_root_func'
        name='is_root_func'
        value='1'
        initialValue={formData.is_root_func}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "1",
            is_root: 1,
            is_func: 0,
          })
        }
      />

      <InputRadioButton
        label={"Is Func"}
        size={"15"}
        id='is_root_func2'
        name='is_root_func2'
        value='2'
        initialValue={formData.is_root_func}
        disabled={true}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "2",
            is_root: 0,
            is_func: 1,
          })
        }
      />

      <InputRadioButton
        label={"Is Menu"}
        size={"15"}
        id='is_root_func3'
        name='is_root_func3'
        value='3'
        initialValue={formData.is_root_func}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "3",
            is_root: 0,
            is_func: 0,
          })
        }
      />
    </div>
  );
};

const RenderIsRootParentFalse = ({ formData, setFormData }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        marginLeft: "5px",
        marginTop: "0.5rem",
      }}>
      <InputRadioButton
        label={"Is Root"}
        size={"15"}
        id='is_root_func'
        name='is_root_func'
        disabled={true}
        value='1'
        initialValue={formData.is_root_func}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "1",
            is_root: 1,
            is_func: 0,
          })
        }
      />

      <InputRadioButton
        label={"Is Func"}
        size={"15"}
        id='is_root_func2'
        name='is_root_func2'
        value='2'
        initialValue={formData.is_root_func}
        checked={true}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "2",
            is_root: 0,
            is_func: 1,
          })
        }
      />

      <InputRadioButton
        label={"Is Menu"}
        size={"15"}
        id='is_root_func3'
        name='is_root_func3'
        value='3'
        disabled={true}
        initialValue={formData.is_root_func}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "3",
            is_root: 0,
            is_func: 0,
          })
        }
      />
    </div>
  );
};

const RenderCaseRootAndFuncAddViaChild = ({ formData, setFormData }) => {
  if (formData.is_root_parent === 1 || formData.is_root_parent) {
    return (
      <RenderIsRootParentTrue formData={formData} setFormData={setFormData} />
    );
  }

  if (
    (formData.is_root_parent === 0 || formData.is_root_parent === false) &&
    (formData.is_func_parent === 0 || formData.is_func_parent === false)
  ) {
    return (
      <RenderIsRootParentFalse formData={formData} setFormData={setFormData} />
    );
  }

  return <div> RENDER CASE ROOT FUNC VIA CHILD </div>;
};

export default RenderCaseRootAndFuncAddViaChild;
